var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.certificationText)?_c('span',{class:[
		'cert',
		{
			'cert--is': _vm.isCertification,
			'cert--not': !_vm.isCertification,
		},
	]},[_vm._v(" "+_vm._s(_vm.certificationText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }